export enum ClaimAction {
    "Form Created" = 1,
    "Submitted For Investigation" = 2,
    "Part Valid" = 3,
    "Set As Valid" = 4,
    "Set As Invalid" = 5,    
    "Submit For Approval" = 6,
    "Approve" = 7,
    "Close" = 8,
    "Reset Claim" = 9,
    "Cancel Claim" = 10,    
    "Account Manager Changed" = 11,   
    "Submitted For Level 2 Investigation" = 12,
    "Reject" = 13
}